import { Button, DataSource, HorizontalSpacer, Label, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutChangeOptions extends Layout {
    buttonGenerateDefaults: Button;
    buttonRevert: Button;
    horizontalspacer1: HorizontalSpacer;
    labelWarning: Label;
    sourceEdiChangeField: DataSource;
    sourceEdiorderProfileDisplay: DataSource;
    tableChangeFieldTableOnly: Table;
}
